import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function ellipsisMiddle(
	text: string,
	startLength: number,
	endLength: number,
): string {
	if (text.length <= startLength + endLength) {
		return text;
	}
	const start = text.slice(0, startLength);
	const end = text.slice(-endLength);
	return `${start}...${end}`;
}

export function formatContextSize(size: number): string {
	if (size >= 1_000_000) {
		return `${(size / 1_000_000).toFixed(1)}M`;
	}
	if (size >= 1000) {
		return `${(size / 1000).toFixed(0)}K`;
	}
	return size.toString();
}
